// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3VuGp","content":"LoadingAlert_content__1-9Ye"};